import {
  Card,
  Flex,
  styled,
  DrawerCloseButton,
  FloraButton,
  Button as ButtonDeprected,
  Input as DeprectedInput,
} from '@grupoboticario/flora-react';

const styles = {
  FormLayout: styled(Flex, {
    flexDirection: 'column',
    justifyContent: 'center',
    margin: '$4 0',
  }),

  FormWrapper: styled(Flex, {
    flexDirection: 'column',

    '& > div > input': {
      color: '$nonInteractivePredominant',
      fontSize: '$bodyLargeStandard',
      fontWeight: '$medium',
    },
  }),

  ButtonInputs: styled(ButtonDeprected, {
    // '& svg': {
    //   width: '24px',
    //   height: '24px',
    // }, -- voltar quando utilizar o FloraInput
  }),

  CallCenterButtom: styled(FloraButton, {
    padding: '$4 0',
  }),

  InfoUtilCard: styled(Card, {
    alignItems: 'center',
    border: 'solid 1px $medium-light-2',
    display: 'flex',
    flexDirection: 'column',
    height: '$20',
    justifyContent: 'center',
    textAlign: 'center',
    width: '100%',
  }),

  InfoUtilsWrapper: styled(Flex, {
    width: '100%',
    margin: '$5 0',

    '& > a': {
      width: '100%',
      '&:hover': {
        textDecoration: 'none',
      },
    },
  }),

  Tag: styled(Flex, {
    background: '$alert-alt',
    borderRadius: '$small',
    color: '$dark-light',
    padding: '$2',
    marginTop: '$5',
    alignItems: 'center',

    '& svg': {
      marginRight: '$2',
    },
  }),

  SecurityWrapper: styled(Flex, {
    justifyContent: 'center',
    width: '100%',

    '& > span': {
      color: '$medium-medium',
    },
  }),

  ForgotPassword: styled(Flex, {
    marginBottom: '$3',
  }),

  ForgotPasswordButton: styled(FloraButton, {
    padding: '$2 $3',
  }),

  DrawerCloseButton: styled(DrawerCloseButton, {
    cursor: 'pointer',
  }),

  Input: styled(DeprectedInput, {
    marginBottom: '25px',
  }),
};

export default styles;
